/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import type { GridColumnDef } from "../types";

export const SelectViewer = defineComponent({
  name: "SelectViewer",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: null as any, default: null },
  },
  setup(props) {
    return () => {
      const { column: col, value } = props;

      if (value === null || value === undefined || value === "") {
        return <span class="lg-cell-text lg-cell-placeholder">—</span>;
      }

      const option = (col.options ?? []).find((o) => String(o.value) === String(value));
      if (!option) return <span class="lg-cell-text">{String(value)}</span>;

      return (
        <span class="lg-cell-badge">
          {option.icon && (
            <span class="material-symbols-outlined badge-icon">{option.icon}</span>
          )}
          <span>{option.label}</span>
        </span>
      );
    };
  },
});
